import { motion } from 'framer-motion';
import Avatar from './Avatar';

export default function Timeline({ items, className = '' }) {
    const typeIcons = {
        created: 'bi-plus-circle',
        updated: 'bi-pencil',
        deleted: 'bi-trash',
        email: 'bi-envelope',
        call: 'bi-telephone',
        meeting: 'bi-calendar-event',
        note: 'bi-sticky',
        status: 'bi-toggle-on',
        default: 'bi-circle',
    };

    const typeColors = {
        created: 'success',
        updated: 'primary',
        deleted: 'danger',
        email: 'info',
        call: 'warning',
        meeting: 'purple',
        note: 'secondary',
        status: 'primary',
        default: 'secondary',
    };

    return (
        <div className={`timeline ${className}`}>
            {items.map((item, index) => (
                <motion.div
                    key={item.id || index}
                    className="timeline-item"
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: index * 0.1 }}
                >
                    <div className="timeline-marker">
                        <span className={`timeline-icon bg-${typeColors[item.type] || typeColors.default}-subtle text-${typeColors[item.type] || typeColors.default}`}>
                            <i className={`bi ${typeIcons[item.type] || typeIcons.default}`}></i>
                        </span>
                    </div>
                    <div className="timeline-content">
                        <div className="d-flex align-items-start justify-content-between">
                            <div className="flex-grow-1">
                                <p className="mb-1">{item.content}</p>
                                <div className="d-flex align-items-center gap-2 text-muted small">
                                    {item.user && (
                                        <>
                                            <Avatar name={item.user} size="xs" />
                                            <span>{item.user}</span>
                                            <span>•</span>
                                        </>
                                    )}
                                    <span>{item.time}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.div>
            ))}
        </div>
    );
}
